import { render, staticRenderFns } from "./professional_data_step.vue?vue&type=template&id=3e80b379&scoped=true"
import script from "./professional_data_step.vue?vue&type=script&lang=js"
export * from "./professional_data_step.vue?vue&type=script&lang=js"
import style0 from "./professional_data_step.vue?vue&type=style&index=0&id=3e80b379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e80b379",
  null
  
)

export default component.exports